

// ── Shipment Edit Service ──────────────────────────────────────────────────────

import { axiosInstance } from "../../../../utility/apiInstance";
import { ITrackingNumberAssignPayload, IUpdateShipmentPayload } from "./Shipmentedittypes ";

/**
 * Updates origin, destination, pkts, and weight for a shipment.
 * Uses the appropriate endpoint based on shipment type.
 */
export const updateShipmentDetails = async (
    payload: IUpdateShipmentPayload
): Promise<void> => {
    const { type, trackingNumber, ...rest } = payload;

    if (type === 'air') {
        await axiosInstance.put(`/api/v1/airwaybill/update-details/${trackingNumber}`, rest);
    } else {
        await axiosInstance.put(`/api/v1/ocean/update-details/${trackingNumber}`, rest);
    }
};

/**
 * Assigns a new AWB / Ocean tracking number to a shipment.
 * This is a one-time activity — once set, the number is locked.
 *
 * Air:   POST /api/v1/airwaybill/assign-awb
 *        body: { uniqueValue, awbNumber }
 *
 * Ocean: POST /api/v1/ocean/assign-tracking-number
 *        body: { uniqueValue, oceanTrackingNumber }
 */
export const assignTrackingNumber = async (
    payload: ITrackingNumberAssignPayload
): Promise<void> => {
    const { type, uniqueValue, trackingNumber } = payload;

    if (type === 'air') {
        await axiosInstance.post('/api/v1/airwaybill/assign-awb', {
            uniqueValue,
            awbNumber: trackingNumber,
        });
    } else {
        await axiosInstance.post('/api/v1/ocean/assign-tracking-number', {
            uniqueValue,
            oceanTrackingNumber: trackingNumber,
        });
    }
};

/** Convenience: determine if the existing mawb represents a "real" tracking
 *  number (i.e. has been assigned) or is still the internal uniqueValue.
 *  Adjust this heuristic to match your actual data model.
 */
export const isTrackingNumberAssigned = (awbLocked: boolean): boolean => {
    return awbLocked;
};